export { default } from './AdminManagement';
export { default as reducer } from './AdminManagement.slice';
export { default as sagas } from './AdminManagement.sagas';

import * as actions from './AdminManagement.slice';

export { actions };
